import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/auth/LoginPage';
import DashboardLayout from './layouts/DashboardLayout';
import AdminDashboard from './pages/AdminDashboard';
import UserManagementPage from './pages/user/UserManagementPage';
import UserProfilePage from './pages/UserProfilePage';
import PlanManagementPage from './pages/subscription-plan/PlanManagementPage';
import DeviceManagementPage from './pages/DeviceManagementPage';
import ReportsPage from './pages/ReportsPage';
import NotificationsPage from './pages/NotificationsPage';
import ReceptionistDashboard from './pages/ReceptionistDashboard';
import EnquiryManagementPage from './pages/EnquiryManagementPage';
import ReceptionistMemberProfilePage from './pages/ReceptionistMemberProfilePage';
import PaymentManagementPage from './pages/PaymentManagementPage';
import MemberCheckInPage from './pages/MemberCheckInPage';
import ReceptionistReportsPage from './pages/ReceptionistReportsPage';
import ReceptionistNotificationsPage from './pages/ReceptionistNotificationsPage';
import PlanSessionManagementPage from './pages/subscription-plan/PlanSessionManagementPage';
import ProtectedRoute, { LoginRedirect, PublicRoute } from './ProtectedRoute';
import RecUserManagementPage from './pages/user/RecUserManagementPage';
import Settings from './pages/settings/Settings';
import ResetPassword from './pages/auth/ResetPassword';
import GlobalCalendarPage from './pages/calendar/GlobalCalendarPage';
import { useLoaderStore } from './services/LoadStore';

function App() {
    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });
        const { loading } = useLoaderStore(); 

    return (
        <>
            {/* 🔥 Global Loader */}
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9999]">
                    <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
            )}
            <Toaster
                position="top-right"
                reverseOrder={false}
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: '#333',
                        color: '#fff',
                    },
                    success: {
                        style: {
                            background: '#00C853',
                        },
                    },
                    error: {
                        style: {
                            background: '#FF3B30',
                        },
                    },
                }}
            />
            <Router>
                <Routes>
                    {/* ✅ Login Page always accessible */}
                    <Route path="/login" element={<LoginRedirect />} />
                    <Route path="/reset-password/:id" element={<ResetPassword />} />

                    {/* ✅ Public redirect from "/" */}
                    <Route path="/" element={<PublicRoute />}></Route>

                    {/* 🔒 Admin Protected Routes */}
                    <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
                        <Route path="/admin" element={<DashboardLayout userRole="admin" />}>
                            <Route index element={<Navigate to="dashboard" replace />} />
                            <Route path="dashboard" element={<AdminDashboard />} />
                            <Route path="users" element={<UserManagementPage />} />
                            <Route path="users/:userId" element={<UserProfilePage />} />
                            <Route path="plans" element={<PlanManagementPage />} />
                            <Route path="devices" element={<DeviceManagementPage />} />
                            <Route path="payments" element={<PaymentManagementPage />} />
                            <Route path="calendar" element={<GlobalCalendarPage userRole={"admin"} />} />

                            <Route path="reports" element={<ReportsPage />} />
                            <Route path="notifications" element={<NotificationsPage />} />
                            <Route path="settings" element={<Settings />} />
                        </Route>
                    </Route>

                    {/* 🔒 Receptionist Protected Routes */}
                    <Route element={<ProtectedRoute allowedRoles={["receptionist"]} />}>
                        <Route path="/receptionist" element={<DashboardLayout userRole="receptionist" />}>
                            <Route index element={<Navigate to="dashboard" replace />} />
                            <Route path="dashboard" element={<ReceptionistDashboard />} />
                            <Route path="enquiries" element={<EnquiryManagementPage />} />
                            {/* <Route path="members/:memberId" element={<ReceptionistMemberProfilePage />} /> */}
                            <Route path="members/:userId" element={<UserProfilePage />} />
                            <Route path="members" element={<RecUserManagementPage />} />
                            <Route path="check-in" element={<MemberCheckInPage />} />
                            <Route path="plans" element={<PlanManagementPage isAdmin={false} />} />
                            <Route path="schedule" element={<PlanSessionManagementPage />} />
                            <Route path="payments" element={<PaymentManagementPage />} />
                            {/* <Route path="reports" element={<ReceptionistReportsPage />} /> */}
                            <Route path="calendar" element={<GlobalCalendarPage userRole={"receptionist"} />} />

                            <Route path="reports" element={<ReportsPage />} />
                            <Route path="notifications" element={<ReceptionistNotificationsPage />} />
                            {/* <Route path="settings" element={<Settings />} /> */}
                        </Route>
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </>
    );
}

export default App;
